(function ($, root, undefined) {
    $(function () {
        const Cookies = require('./components/cookies_handler');
        const HeroSection = require('./components/pages/HeroSectionSection');
        const Header = require('./components/header');
        const Homepage = require('./components/homepage/homepage');
        const Services = require('./components/pages/ServicesSection');
        const Tabs = require('./components/pages/TabsSection');
        const ImageTextShowSection = require('./components/pages/ImageTextShowMoreSection');
        const VideoSection = require('./components/pages/VideoSection');
        const ActiveJobs = require('./components/pages/activeJobListSection');
    });
})(jQuery, this);